var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Glyphs/Share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Share",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-essential-278",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 26 0 26 26 0 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(4.333333, 3.250000)",
    stroke: "currentColor",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33333333,7.58333333 L2.16666667,7.58333333 C0.969583333,7.58333333 0,8.55291667 0,9.75 L0,17.3333333 C0,18.5304167 0.969583333,19.5 2.16666667,19.5 L15.1666667,19.5 C16.36375,19.5 17.3333333,18.5304167 17.3333333,17.3333333 L17.3333333,9.75 C17.3333333,8.55291667 16.36375,7.58333333 15.1666667,7.58333333 L13,7.58333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.66666667,
    y1: 0,
    x2: 8.66666667,
    y2: 11.9166667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5.41775 3.25 8.66666667 0 11.9166667 3.25"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3b4c650a.svg";
export { ForwardRef as ReactComponent };